module.exports = __webpack_public_path__ + "img/9788989722595.4b332cb5.jpg";